import React from 'react';
import cls from '../../utils/classnames';
import { autobind } from 'packages/core/lib';
import { KEYBOARD_KEY } from '../../utils/classes';
import './_styles.scss';

export interface IKeyProps {
    /**
     * A string to render as text and use as value on onClick events.
     */
    children: JSX.Element | string;
    /**
     * Value of the key.
     * This is only used when you wan't the value to not be a string.
     */
    value?: string | symbol;
    /**
     * Inline styles.
     */
    style?: React.CSSProperties;
    /**
     * class name to add to element
     * */
    className?: string;
    /**
     * callback to be executed when click on it
     */
    onClick(value: string | symbol): void;
}

export class Key extends React.PureComponent<IKeyProps> {
    @autobind
    private onClick(): void {
        const { onClick } = this.props;

        if (typeof onClick === 'function') {
            const { value } = this.props;

            if (value) {
                onClick(value);
            } else {
                const { children } = this.props;
                onClick(children as string);
            }
        }
    }

    public render(): JSX.Element {
        const { children, style: styles, className } = this.props;
        const classNames = cls(KEYBOARD_KEY, className);
        return (
          <a
            style={styles}
            onClick={this.onClick}
            className={cls(`${KEYBOARD_KEY}-href`, `${classNames}`, `${KEYBOARD_KEY}-href-letter`)}
            href="javascript:void(0)"
          >
            {children}
          </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/Keyboard/Key/index.tsx